import error_children from './errors'

const full_pages = [
    // =============================================================================
    // PAGES
    // =============================================================================
    {
        name: 'register',
        path: '/',
        meta: {
            require_auth: false,
            title: 'Register',
            slug: 'register',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/register/Register.vue')
        // children: [

        // ]
    },
    {
        name: 'registerSuccess',
        path: 'registerSuccess',
        meta: {
            require_auth: false,
            title: 'Register success',
            slug: 'registerSuccess',
            icon: '',
            searchable: false,
            param_restrictions: {}
            // parent: 'register'
        },
        component: () => import('@/views/register/RegisterSuccess.vue')
    },
    {
        name: 'purchase',
        path: '/purchase',
        meta: {
            require_auth: true,
            title: 'Purchase',
            slug: 'purchase',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/register/Purchase.vue')
    },
    {
        name: 'welcome',
        path: '/welcome',
        meta: {
            require_auth: true,
            title: 'Welcome',
            slug: 'welcome',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/register/Welcome.vue')
    },
    {
        path: 'profile',
        name: 'user-profile',
        meta: {
            require_auth: true,
            require_role: [],
            title: 'Profile',
            icon: 'UserIcon',
            slug: 'profile',
            searchable: true,
            param_restrictions: {}
        },
        component: () => import('@/views/profile/UserProfile.vue')
    },
    {
        name: 'login',
        path: '/account',
        redirect: '/account/login',
        meta: {
            require_auth: false,
            title: 'Login',
            slug: 'account',
            icon: '',
            searchable: false,
            param_restrictions: {}
        }
    },
    {
        path: '/account/:action',
        name: 'auth',
        meta: {
            require_auth: false,
            title: 'Login',
            slug: 'account',
            icon: 'LogInIcon',
            searchable: false,
            param_restrictions: {
                action: ['login', 'reset', 'register', 'verify', 'forgot', 'activate']
            }
        },
        component: () => import('@/views/login/Login.vue')
    },
    {
        name: 'redeem-landing',
        path: 'redeem/:couponCode?',
        meta: {
            require_auth: false,
            title: 'Redeem Coupon',
            slug: 'coupon',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/redemption/RedemptionLanding.vue')
    },
    {
        name: 'redeem-register',
        path: 'redeem-register',
        meta: {
            require_auth: false,
            title: 'Redeem Coupon',
            slug: 'coupon',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/redemption/RedemptionRegister.vue')
    },
    {
        name: 'redeem-existing',
        path: 'redeem-existing',
        meta: {
            require_auth: false,
            title: 'Redeem Coupon',
            slug: 'coupon',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/redemption/RedemptionExisting.vue')
    },

    {
        name: 'deep-link-landing',
        path: 'deeplink/:tileIDFromURL?',
        meta: {
            require_auth: false,
            title: 'Deep Link',
            slug: 'tileIDFromURL',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/deeplink/DeepLinkLanding.vue')
    },

    {
        name: 'success',
        path: 'success',
        meta: {
            require_auth: false,
            title: 'Success',
            slug: 'success',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/redemption/Success.vue')
    },

    {
        name: 'coupons',
        path: 'coupons',
        meta: {
            require_auth: true,
            require_role: ['SuperUser'],
            title: 'Coupons'
        },
        component: () => import('@/views/admin/coupons/Main.vue'),
        children: [
            {
                name: 'create_coupon',
                path: 'new',
                meta: {
                    require_auth: true,
                    require_role: ['SuperUser'],
                    title: 'Create Coupon',
                    slug: 'coupons/new',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'coupons'
                },
                component: () => import('@/views/admin/coupons/components/CreateCoupon.vue')
            },
            {
                name: 'couponList',
                path: '/',
                meta: {
                    require_auth: true,
                    require_role: ['SuperUser'],
                    title: 'Coupons',
                    slug: 'coupons',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'coupons'
                },
                component: () => import('@/views/admin/coupons/components/Coupons.vue')
            },
            {
                name: 'editCoupon',
                path: ':coupon_id',
                meta: {
                    require_auth: true,
                    require_role: ['SuperUser'],
                    title: 'Edit Coupon',
                    slug: 'coupons/edit',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'coupons'
                },
                component: () => import('@/views/admin/coupons/components/CreateCoupon.vue')
            }
        ]
    },
    {
        name: 'products',
        path: 'products',
        meta: {
            require_auth: true,
            require_role: ['SuperUser'],
            title: 'Products'
        },
        component: () => import('@/views/admin/products/Main.vue'),
        children: [
            {
                name: 'create_product',
                path: 'new',
                meta: {
                    require_auth: true,
                    require_role: ['SuperUser'],
                    title: 'Create product',
                    slug: 'products/new',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'products'
                },
                component: () => import('@/views/admin/products/components/CreateProduct.vue')
            },
            {
                name: 'productList',
                path: '/',
                meta: {
                    require_auth: true,
                    require_role: ['SuperUser'],
                    title: 'Products',
                    slug: 'products',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'products'
                },
                component: () => import('@/views/admin/products/components/Products.vue')
            },
            {
                name: 'editProduct',
                path: ':product_id',
                meta: {
                    require_auth: true,
                    require_role: ['SuperUser'],
                    title: 'Edit Product',
                    slug: 'product/edit',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'products'
                },
                component: () => import('@/views/admin/products/components/CreateProduct.vue')
            }
        ]
    },
    {
        name: 'users',
        path: 'users',
        meta: {
            require_auth: true,
            require_role: ['SuperUser'],
            title: 'Users'
        },
        component: () => import('@/views/admin/users/Main.vue'),
        children: [
            {
                name: 'userList',
                path: '/',
                meta: {
                    require_auth: true,
                    require_role: ['SuperUser'],
                    title: 'Users',
                    slug: 'users',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'users'
                },
                component: () => import('@/views/admin/users/components/Users.vue')
            }
        ]
    },

    {
        name: 'wellfulHome',
        path: 'http://www.wellful.com.au',
        meta: {
            require_auth: null,
            title: 'Home',
            slug: 'external',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/Home.vue')
    },
    {
        name: 'wellfulAbout',
        path: 'about',
        meta: {
            require_auth: false,
            title: 'About',
            slug: 'wellfulAbout',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/about/About.vue')
    },
    {
        name: 'wellfulContact',
        path: 'contact',
        meta: {
            require_auth: false,
            title: 'Contact',
            slug: 'wellfulContact',
            icon: '',
            searchable: false,
            param_restrictions: {}
        },
        component: () => import('@/views/contact/Contact.vue')
    },

    {
        name: 'players',
        path: 'players',
        meta: {
            require_auth: true,
            require_role: ['Content_Creator'],
            title: 'Players'
        },
        component: () => import('@/views/admin/playlists/Main.vue'),
        children: [
            {
                name: 'new-player',
                path: 'new',
                meta: {
                    require_auth: true,
                    require_role: ['Content_Creator'],
                    title: 'Create Content',
                    slug: 'players/new',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'players'
                },
                component: () => import('@/views/admin/playlists/PlayerDetails.vue')
            },
            {
                name: 'players-list',
                path: '/',
                meta: {
                    require_auth: true,
                    require_role: ['Content_Creator'],
                    title: 'Players',
                    slug: 'players',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'players'
                },
                component: () => import('@/views/admin/playlists/PlayersTable.vue')
            },
            {
                name: 'edit-player',
                path: ':playlist_id',
                meta: {
                    require_auth: true,
                    require_role: ['Content_Creator'],
                    title: 'Edit Player',
                    slug: 'players/edit',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'players'
                },
                component: () => import('@/views/admin/playlists/PlayerDetails.vue')
            }
        ]
    },

    {
        name: 'authors',
        path: 'authors',
        meta: {
            require_auth: true,
            require_role: ['Content_Creator'],
            title: 'Authors'
        },
        component: () => import('@/views/admin/authors/Main.vue'),
        children: [
            {
                name: 'create-author',
                path: 'new',
                meta: {
                    require_auth: true,
                    require_role: ['Content_Creator'],
                    title: 'Create Author',
                    slug: 'authors/new',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'authors'
                },
                component: () => import('@/views/admin/authors/AuthorDetails.vue')
            },
            {
                name: 'authorList',
                path: '/',
                meta: {
                    require_auth: true,
                    require_role: ['Content_Creator'],
                    title: 'Authors',
                    slug: 'authors',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'authors'
                },
                component: () => import('@/views/admin/authors/AuthorsTable.vue')
            },
            {
                name: 'editAuthor',
                path: ':author_id',
                meta: {
                    require_auth: true,
                    require_role: ['Content_Creator'],
                    title: 'Edit Author',
                    slug: 'authors/edit',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'authors'
                },
                component: () => import('@/views/admin/authors/AuthorDetails.vue')
            }
        ]
    },

    {
        name: 'genres',
        path: 'genres',
        meta: {
            require_auth: true,
            require_role: ['Content_Creator'],
            title: 'Genres'
        },
        component: () => import('@/views/admin/genres/Main.vue'),
        children: [
            {
                name: 'create-genre',
                path: 'new',
                meta: {
                    require_auth: true,
                    require_role: ['Content_Creator'],
                    title: 'Create Genre',
                    slug: 'genres/new',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'genres'
                },
                component: () => import('@/views/admin/genres/GenreDetails.vue')
            },
            {
                name: 'genreList',
                path: '/',
                meta: {
                    require_auth: true,
                    require_role: ['Content_Creator'],
                    title: 'Genres',
                    slug: 'genres',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'genres'
                },
                component: () => import('@/views/admin/genres/GenresTable.vue')
            },
            {
                name: 'editGenre',
                path: ':genre_id',
                meta: {
                    require_auth: true,
                    require_role: ['Content_Creator'],
                    title: 'Edit Genre',
                    slug: 'genres/edit',
                    icon: '',
                    searchable: false,
                    param_restrictions: {},
                    parent: 'genres'
                },
                component: () => import('@/views/admin/genres/GenreDetails.vue')
            }
        ]
    },

    ...error_children
]

export default full_pages
